const CONFIG = process.env.VUE_APP_CONFIG

console.log('environment:', CONFIG.environment.value)

const OK_FORM_API = CONFIG.api.okForm
const getApiUrlWithVersion = (version) => `${OK_FORM_API.baseUrl}/v${version}`

export const DEV_TOOLS = CONFIG.devTools

export const APP_VERSION = CONFIG.appInfo.version
export const ENV = CONFIG.environment
export const API_URL = getApiUrlWithVersion('1.0')
export const SENTRY_DSN = CONFIG.sentry.dsn
export const SENTRY_ENV = CONFIG.sentry.env
export const SENTRY_RELEASE = `${CONFIG.appInfo.name}@${APP_VERSION}`
